<template>

    <div class="vip-wrap">
        <div class="table-wrap">
            <table class="var-table" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th class="title-vip-type" rowspan="2"><span>{{msg('会员类型')}}</span></th>
                        <th class="title-group" :colspan="licenseLength"><span>{{msg("可拥有账号个数")}}</span></th>
                    </tr>
                    <tr class="title-license">
                        <th v-for="(remark, idx) in remarks" :key="idx"><span>{{remark}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(value, key) in vips" :key="key">
                        <td v-if="vipBuyType&&vipBuyType.indexOf(key)>-1" class="cell-vip">
                            <span>{{vipLabels[key]}}
                                <br><span v-show="key!='vip6'&&key!='vip7'&&key!='vip9'" style="font-size:15px;">{{msg('赠送可绑店铺总数')}}<span style="font-size:20px;font-weight:bold">{{shopLabels[key]}}</span>{{' 家'}}</span>
                            </span>
                        </td>
                        <template v-if="vipBuyType&&vipBuyType.indexOf(key)>-1">
                            <td v-for="(val, idx) in value" :class="['cell-price', (currVipKey===key && currVipIdx==idx)? 'active':'']" @click="checkVip(val, key, idx)" :key="idx">
                                <span>{{(val.price/100).toFixed(2)}}<span style="font-size:18px;">元/月</span></span>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="vipBuyType&&vipBuyType.indexOf('vip1')<0&&vipBuyType.indexOf('vip2')<0&&vipBuyType.indexOf('vip3')<0" style="text-align:center; margin-top: 10px;margin-bottom: 10px; padding:10px;font-size:16px;color:red;" class="vip-auth">
            <el-checkbox-group v-model="saleIds">
                <el-checkbox v-model="saleIds" @change="(val)=>handerSaleChange(val, sale)"  
                    v-for="sale in sales" style="margin:10px;" :label="sale.id" :key="sale.id" 
                    border size="medium"
                    :disabled="!currVipKey"
                >{{sale.remark}}</el-checkbox>
            </el-checkbox-group>
        </div>

        <div style="text-align:center;margin:10px;">
            <div style="margin:10px;color:#F56C6C;font-weight:bold">
                <span>{{msg('升级套餐内店铺绑定数量：')}}</span><el-switch v-model="buyShop" active-text="开" inactive-text="关" :disabled="buyShopDisabled" active-color="#13ce66" inactive-color="#ff4949" @change="buyShopChange"></el-switch>
                <div style="margin:10px;"><span>{{msg('升级套餐绑定店铺总数至 ')}}</span><el-input-number size="mini" v-model="shopQtyLevel" :disabled="!showShopQty" :step="1" :min="1" :max="100" @change="handerShopQtyChange" @blur="handerShopQtyBlur" :step-strictly="true"></el-input-number><span> {{msg('级【注：每提升1级可多绑10家店铺】')}}</span></div>
            </div>
            <el-button type="danger" round @click="prepareBuy">
            <i class="el-icon-shopping-cart-full" style="font-size:20px;"></i>
            <span style="display:inline-block; margin-left:5px;" v-if="vipTxt">{{vipTxt}}</span>
            <span style="display:inline-block; margin-left:5px;" v-if="qtyTxt">{{qtyTxt}}</span>
            <span style="display:inline-block; margin-left:5px;" v-if="shopQtyTxt">{{shopQtyTxt}}</span>
            <span style="display:inline-block; margin-left:5px;" v-if="saleTxt">{{saleTxt}}</span>
            <span style="display:inline-block; margin-left:10px; font-size:20px" ><span>￥</span>{{(amount * currMonths * currSale).toFixed(2)}}</span>
            </el-button>
        </div>

        <div class="vip-auth" style="font-size:18px;color: #f30c0c;">
            <span>温馨提示：续费后会员权限如没有生效，可点击左上方【续费】入口旁的小灯泡图标，按里面的提示检查操作一下即可；</span>
        </div>

        <div class="vip-auth" v-if="remark1Txt">
            <span v-html="remark1Txt"></span>
            <span v-html="remark2Txt"></span>
            <span v-html="remark3Txt"></span>
        </div>

        <div class="vip-auth" style="font-size:18px;color: #f30c0c;">
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;续费声明：在你续费前，特此向你说明关于退费的相关事宜。当你完成续费操作，即代表你已确认并同意接受套餐内提供的功能服务。续费金额将即刻用于激活你后续的会员功能为你提供相应服务，无论你是否实际使用或使用程度如何，以确保你的会员权益得以保障与实现，我们所涉及的资源已为你筹备并投入，因此，续费一旦完成，所缴纳的费用将不予退还。请你在续费前仔细考量自身需求与意愿！</span>
            <span style="margin-top:10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会员套餐可根据自身实际需要随时调整更换；更换套餐时，前套餐内没用完的会员时间系统会自动换算成金额补偿到新套餐；如补偿新套餐金额不够，系统会提示您补差价；如补偿新套餐后金额还有剩余，剩余金额系统将默认您自动放弃作清零处理；</span>
            <span style="margin-top:10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;举例解释：如您续费了一个900元/月的会员套餐，平均是：900÷30=30元/天；使用10天后更换套餐，前套餐还剩20天没用完，转换成金额预估为：20×30=600元；
            这时如要更换到1500元/月的会员套餐，因前套餐预估有价值600元的会员时间没有使用完，系统会自动补到新套餐，并给出需要补1500-600=900元差价的提示；</span>
            <span style="margin-top:10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如这时不是更换到1500元/月的会员套餐，而是500元/月的会员套餐时，因前套餐预估有价值600元的会员时间没有使用完，系统会用这600元来补给这个500元/月的新套餐，补给新套餐后多出来的600-500=100元，系统将默认您自动放弃作清零处理；</span>
        </div>

    </div>

</template>

<script>
export default {
    name: 'role',
    components: {},
    mounted:function(){
        this.getVipSet();
        this.list();
        this.getShopQtyNum();
    },
    data(){
        return{
            licenseLength: 0,
            remarks: [],
            prices: [],
            vips: {},
            sales: [],
            vipLabels: {},
            shopLabels:{},
            saleIds: [],
            vipTxt: "普通会员",
            qtyTxt: "1-10用户",
            shopQtyTxt:"3家",
            saleTxt: "",
            amount: 50,
            shopQty:20,
            shopQtyLevel:1,
            showShopQty:false,
            buyShop:false,
            buyShopDisabled:false,
            
            currMonths: 1,
            currSale: 1,

            currVipKey: null,
            currVipIdx: null,
            currVip: null,

            remark1Txt:null,
            remark2Txt:null,
            remark3Txt:null,

            vipBuyType:null,
        }
    },
    methods: {
        getVipSet(){
            this.$axios.get(this.$kit.api.user.getVipSet)
                .then((result)=>{
                    if(result.status){
                        var u = result.data;
                        this.vipBuyType = u.vipBuyType;
                    }
                });
        },
        list(){
            this.$axios.get(this.$kit.api.vip.prices)
                .then((result)=>{
                    if(result.status){
                        let data = result.data;
                        this.prices = data.vips;
                        this.sales = data.sales;
                        let vs = {}
                        this.prices.forEach(p => {

                            let vip = vs[p.vip];
                            if(!vip){
                                vip = [];
                                vs[p.vip] = vip;
                            }

                            this.vipLabels[p.vip]=p.vipLabel;
                            vip.push(p);
                           
                        });
                        this.vips = vs;
                        this.remarks = this.vips["vip1"].map(e => e.remark1);
                        this.licenseLength = this.vips["vip1"].length;
                    }
                });
        },
        getShopQtyNum(){
            this.$axios.get(this.$kit.api.shop.getShopQtyNum)
                .then((result)=>{
                    if(result.status){
                        let data = result.data;
                        this.shopLabels = {
                            'vip1':data.vip1,
                            'vip2':data.vip2,
                            'vip3':data.vip3,
                            'vip5':data.vip5,
                            'vip6':data.vip6,
                            'vip7':data.vip7,
                            'vip9':data.vip9,
                        }
                    }
                });
        },
        handerSaleChange(val, sale){
            if(val){
                this.saleIds = [sale.id];
                this.saleTxt = "折扣："+sale.sale+"%";
                this.currMonths = sale.months;
                this.currSale = (sale.sale / 100.0).toFixed(2);
            }else if(this.saleIds.length==0){
                this.saleTxt = "";
                this.currMonths=1;
                this.currSale=1;
            }
        
        },
        buyShopChange(value){
            if(this.currVip == null){
                this.$message(this.msg('请选择要续费的会员类型'));
                this.buyShop = false;
                return;
            }
            if(this.currVipKey == 'vip6' || this.currVipKey == 'vip7' || this.currVipKey == 'vip9'){
                this.$message(this.msg('物流会员不能绑定店铺'));
                this.buyShop = false;
                return;
            }
            let defaultQty = this.shopLabels[this.currVipKey];
            if(value){
                this.showShopQty = true;
                let qty = 0;
                if(this.currVipKey == 'vip1'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
                }else if(this.currVipKey == 'vip2'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
                }else if(this.currVipKey == 'vip3'){
                    this.shopQty = defaultQty;
                    this.shopQtyLevel = 2;
                    qty = this.shopQty-defaultQty;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
                }else if(this.currVipKey == 'vip5'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
                }else if(this.currVipKey == 'vip6' || this.currVipKey == 'vip9'){
                    this.shopQty = 0;
                    this.shopQtyLevel = 1;
                    qty = 0;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "无绑定店铺数量";
                }else if(this.currVipKey == 'vip7'){
                    this.shopQty = 0;
                    this.shopQtyLevel = 1;
                    qty = 0;
                    this.amount = (this.price/100.0+(qty*3)).toFixed(2);
                    this.shopQtyTxt = "电商店铺数无限制";
                }
            }else{
                this.showShopQty = false;
                this.shopQtyLevel = 1;
                this.shopQty = defaultQty;
                this.amount = (this.price/100.0).toFixed(2);
                if(this.currVipKey == 'vip7'){
                    this.shopQtyTxt = "电商店铺数无限制";
                }else if(this.currVipKey == 'vip6' || this.currVipKey == 'vip9'){
                    this.shopQtyTxt = "无绑定店铺数量";
                }else{
                    this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
                }
            }
        },
        checkVip(val, key, idx){
            // console.log(val, key, idx);

            // this.shopQty = this.shopLabels[key];
            if(key == 'vip7'){
                this.buyShopDisabled = true;
            }else{
                this.buyShopDisabled = false;
            }

            let qty = 0;
            // if(key == 'vip3'){
            //     this.showShopQty = true;
            //     qty = (this.shopQty-20)/10;
            // }else{
            //     this.showShopQty = false;
            //     this.shopQty = this.shopLabels[key];
            //     qty = 0;
            // }

            let defaultQty = this.shopLabels[key];
            if(this.buyShop){
                if(key == 'vip1'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                }else if(key == 'vip2'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                }else if(key == 'vip5'){
                    this.shopQty = 10;
                    this.shopQtyLevel = 1;
                    qty = this.shopQty-defaultQty;
                }else if(key == 'vip3'){
                    this.shopQty = defaultQty;
                    this.shopQtyLevel = 2;
                    qty = this.shopQty-defaultQty;
                }else if(key == 'vip6' || key == 'vip7' || key == 'vip9'){
                    this.shopQty = 0;
                    this.shopQtyLevel = 1;
                    qty = 0;
                }
            }else{
                this.shopQty = defaultQty;
            }

            this.currVipKey = key;
            this.currVip=val;
            this.currVipIdx = idx;

            this.vipTxt = val.vipLabel;
            if(key == 'vip7'){
                this.qtyTxt = "账号数量无限制";
                this.shopQtyTxt = "电商店铺数无限制";
            }else if(key == 'vip6' || key == 'vip9'){
                this.qtyTxt = val.remark1;
                this.shopQtyTxt = "无绑定店铺数量";
            }else{
                this.qtyTxt = val.remark1;
                this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
            }

            this.amount = (val.price/100.0+(qty*3)).toFixed(2);
            this.remark1Txt = val.typeRemark1;
            this.remark2Txt = val.typeRemark2;
            this.remark3Txt = val.typeRemark3;
            this.price = val.price;
            
        },
        handerShopQtyChange(currentValue){
            let defaultQty = this.shopLabels[this.currVipKey];
            let key = this.currVipKey;
            let currShopQty = 0;
            if(key == 'vip1'){
                currShopQty = currentValue*10;
            }else if(key == 'vip2'){
                currShopQty = currentValue*10;
            }else if(key == 'vip5'){
                currShopQty = currentValue*10;
            }else if(key == 'vip3'){
                currShopQty = (currentValue-2)*10+20;
            }else if(key == 'vip6' || key == 'vip7' || key == 'vip9'){
                currShopQty = 0;
            }
            if(currShopQty < defaultQty){
                currShopQty = defaultQty;
            }
            let qty = currShopQty-defaultQty;
            this.amount = (this.price/100.0+(qty*3)).toFixed(2);
            if(key == 'vip7'){
                this.shopQtyTxt = "电商店铺数无限制";
            }else if(key == 'vip6' || key == 'vip9'){
                this.shopQtyTxt = "无绑定店铺数量";
            }else{
                this.shopQtyTxt = "可绑店铺总数"+currShopQty+"家";
            }
            this.shopQty = currShopQty;
        },
        handerShopQtyBlur(){
            let defaultQty = this.shopLabels[this.currVipKey];
            if(this.shopQty < defaultQty){
                this.shopQty = defaultQty;
            }
            let qty = this.shopQty-defaultQty;
            this.amount = (this.price/100.0+(qty*3)).toFixed(2);
            let key = this.currVipKey;
            if(key == 'vip7'){
                this.shopQtyTxt = "电商店铺数无限制";
            }else if(key == 'vip6' || key == 'vip9'){
                this.shopQtyTxt = "无绑定店铺数量";
            }else{
                this.shopQtyTxt = "可绑店铺总数"+this.shopQty+"家";
            }
        },
        prepareBuy(){
            if(!this.currVip){
                return; 
            }
            //检查是否有待支付订单，如果有则刷新支付结果，如果没有则直接执行下一步
            let _this = this;
            this.$axios.get(this.$kit.api.vip.checkOrderStatus)
                .then((result)=>{
                    if(result.status){
                        let order = result.data;
                        if(order.status != 1 && order.status != 2){
                            _this.$confirm(_this.msg("您有一笔待支付的订单，是否取消支付？"), _this.msg('支付提醒'), {
                                confirmButtonText: '取消支付',
                                cancelButtonText: '返回',
                                type: 'warning'
                            }).then(() => {
                                _this.cancelOrder(order.id);
                            });
                        }else{
                            _this.$confirm(_this.msg("您的订单已付款，请重新登录后确认？"), _this.msg('支付提醒'), {
                                confirmButtonText: '继续购买',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                _this.doCheckBuy();
                            });
                        }
                    }else{
                        _this.doCheckBuy();
                    }
                });

        },
        cancelOrder(orderId){
            let _this = this;
            this.$axios.get(this.$kit.api.vip.cancelOrder+"?id="+orderId+"&status=5")
                .then((result)=>{
                    if(result.status){
                        _this.doCheckBuy();
                    }else{
                        _this.$message(result.msg);
                    }
                });
        },
        doCheckBuy(){
            let _this = this;
            this.$axios.get(this.$kit.api.vip.checkBuy+"?id="+this.currVip.id+"&t="+this.currVip.vip+"&shopQty="+this.shopQty+"&buyShop="+this.buyShop+"&s="+(this.saleIds.length>0?this.saleIds[0]: ''))
                .then((result)=>{
                    if(result.status){
                        _this.$confirm(result.data.msg+"， 您将要支付 <<"+result.data.amt+">>元差价", _this.msg('支付提醒'), {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            if(result.data.amt == 0){
                                _this.$confirm(this.msg('你正在更换更低费用套餐的操作，该操作系统不会补退多余差价给你，成功后也无法撤回到原套餐，是否愿意放弃原套餐多余差价继续降到低套餐？'), this.msg('重要提醒：'), {
                                    confirmButtonText: '确认更改',
                                    cancelButtonText: '取消操作',
                                    type: 'error'
                                }).then(() => {
                                    _this.doBuy();
                                });
                            }else{
                                _this.doBuy();
                            }
                        });
                    }else{
                        _this.$message({
                            message: result.msg,
                            type: 'error'
                        });
                    }
                });
        },
        doBuy(){
            window.open(this.$kit.api.vip.buy+"?id="+this.currVip.id+"&t="+this.currVip.vip+"&shopQty="+this.shopQty+"&buyShop="+this.buyShop+"&s="+(this.saleIds.length>0?this.saleIds[0]: ''));
            this.$confirm(this.msg('支付完成？点击确定查看支付结果'), this.msg('支付提醒'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$tabs.open("/admin/vip-order");
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.vip-wrap{
    width:100%; 
    height:90vh;
    min-height: 600px;
    background: #fffbf5;
    padding:15px;  box-sizing: border-box;
}

.table-wrap{
   box-sizing: border-box;
   min-width:100%;  overflow:auto;
}
.var-table{min-width:100%;}

.title-vip-type{ box-shadow: 0 0 20px rgba(100,100,100,0.4); width:200px;
   background-image: linear-gradient(to right, #FF0033 , #EE8D8D);
   font-size:30px;
   color: #FFCC33;
}

.title-group{background: white;  padding:15px 0px; 
   box-shadow: 0 0 20px rgba(100,100,100,0.4);
    color: #666;
}
.title-license th{background: white; padding:15px 0px; 
   box-shadow: 0 0 20px rgba(100,100,100,0.4); min-width:80px;
    color: #666;
}

.cell-vip{
    // padding:5px; 
    max-width:200px;}
.cell-vip > span{
   display:inline-block;
   padding: 30px 0px;
    width: 200px;max-width:200px; text-align:center;
   background:#fed77c;box-sizing: border-box;
   background-image: linear-gradient(to right, #FF0033 , #EE8D8D);
   color: #FFCC33; font-size:30px;
   box-shadow: 0px 0px 10px rgba(182,148,69, 0.5);
}

.cell-price{padding:5px; white-space:nowrap;height:1px}
.cell-price > span{
    display:flex; 
    width:100%; 
   text-align:center;
   color: #333399; font-size:25px;
   cursor: pointer;
   border:1px solid rgba(51,51,153, 0.2);
   white-space:nowrap;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.cell-price > span:hover, .cell-price.active > span{
   background-image: linear-gradient(to right , #EE8D8D, #FF0033);
   color: #FFCC33;
   box-shadow: 0px 0px 10px rgba(255,0,51, 0.2) inset;
}
.vip-auth{
    margin-bottom:10px;
    padding:15px; 
    font-size:16px; color: #754e3b;
    border: 1.5px solid #ddd;

    >*{
        display:inline-block; margin-right:5px;
    }
}
</style>